export default "__VITE_ASSET__DPI$T7Vv__"